import React, { useState, useRef } from "react";
import "../../common/index.scss";
import SimpleReactValidator from "simple-react-validator";
import { actChangePassword, getUserProfileData } from "../../../actions";
import { connect } from "react-redux";

import RectangleLoader from "../../common/rectangleLoader";
import PasswordInput from "../../common/PasswordInput/PasswordInput";
import classes from "./change_password.module.scss";

const ChangePassword = (props) => {
  const validator = useRef(new SimpleReactValidator({ autoForceUpdate: this }));
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [Data, setData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    email: localStorage.getItem("email"),
  });

  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const setStateFromInput = (event) => {
    event.persist();
    if (event.target.name === "oldPassword" && apiError) {
      setApiError("");
    }
    setData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setApiError("");
    if (validator.current.allValid()) {
      try {
        setLoading(true);
        const changePassword = {
          oldPassword: Data.oldPassword,
          newPassword: Data.newPassword,
          confirmPassword: Data.confirmPassword,
          email: Data.email,
        };
        const response = await props.actChangePassword(changePassword);
        if (
          response &&
          !response.success &&
          response.data &&
          response.data.oldPassword
        ) {
          setApiError(response.data.oldPassword[0]);
        }
      } catch (error) {
        console.error("Error while changing password:", error);
      } finally {
        setLoading(false);
      }
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  return (
    <div className={classes.change_password_page}>
      <div className={classes.card_content}>
        <div className={classes.header}>
          <h1 className={classes.page_title}>Change Password</h1>
          <p className={classes.page_subtitle}>
            Update your password to keep your account secure.
          </p>
        </div>

        <div className={classes.form_wrap}>
          <div className={classes.form_inner}>
            <form className={classes.password_form} onSubmit={handleSubmit}>
              <PasswordInput
                className={classes.form_group}
                wrapperClassName={classes.input_wrapper}
                inputClassName={classes.form_input}
                labelClassName={classes.form_label}
                label={
                  <>
                    Current Password<span className="required-asterisk">*</span>
                  </>
                }
                name="oldPassword"
                id="oldPassword"
                placeholder="Enter the Current Password"
                value={Data.oldPassword}
                onChange={setStateFromInput}
                error={
                  validator.current.message(
                    "current password",
                    Data.oldPassword,
                    "required",
                    {
                      messages: { required: "Enter your current password." },
                    },
                  ) ||
                  (apiError && (
                    <div className="srv-validation-message">{apiError}</div>
                  ))
                }
              />
              <PasswordInput
                className={classes.form_group}
                wrapperClassName={classes.input_wrapper}
                inputClassName={classes.form_input}
                labelClassName={classes.form_label}
                label={
                  <>
                    New Password<span className="required-asterisk">*</span>
                  </>
                }
                name="newPassword"
                id="newPassword"
                placeholder="Enter the New Password"
                value={Data.newPassword}
                onChange={setStateFromInput}
                preventCopyPaste
                error={validator.current.message(
                  "new password",
                  Data.newPassword,
                  "required|min:8|max:30",
                  {
                    messages: {
                      required: "Enter a new password.",
                      min: "Password must be at least 8 characters.",
                      max: "Password must not exceed 30 characters.",
                    },
                  },
                )}
              />
              <PasswordInput
                className={classes.form_group}
                wrapperClassName={classes.input_wrapper}
                inputClassName={classes.form_input}
                labelClassName={classes.form_label}
                label={
                  <>
                    Confirm Password<span className="required-asterisk">*</span>
                  </>
                }
                name="confirmPassword"
                id="confirmPassword"
                placeholder="Enter the Confirm Password"
                value={Data.confirmPassword}
                onChange={setStateFromInput}
                preventCopyPaste
                error={validator.current.message(
                  "confirm password",
                  Data.confirmPassword,
                  `required|min:8|max:30|in:${Data.newPassword}`,
                  {
                    messages: {
                      required: "Re-enter your new password.",
                      min: "Password must be at least 8 characters.",
                      max: "Password must not exceed 30 characters.",
                      in: "Passwords do not match.",
                    },
                  },
                )}
              />
              <div className={classes.form_actions}>
                <button
                  className={`${classes.update_btn} uk-button uk-button-primary`}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <RectangleLoader /> : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile_data: state.data.profile_data,
});

export default connect(mapStateToProps, {
  actChangePassword,
  getUserProfileData,
})(ChangePassword);
